import { ControlledDateOnlyPicker, ControlledSelect, ControlledTextField, useTranslatedOptionEnum } from '@if/mui'
import { Grid, Stack, Typography } from '@mui/material'
import { getEFeeBillingMechanismList } from '@src/types/constants'
import { Control, FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FinanceFeeConfigurationSchemaType, NewLoanDtoSchemaType } from './loan-form-schema'

interface Props<TFieldValues extends FieldValues> {
  control: Control<NewLoanDtoSchemaType, TFieldValues>
  values?: FinanceFeeConfigurationSchemaType
  }

const FeeConfigurationInputRow = <TFieldValues extends FieldValues = FieldValues>({ control }: Props<TFieldValues>) => {
  const { t } = useTranslation()
  const billingMechanismOption = useTranslatedOptionEnum('enum.billingMethod', getEFeeBillingMechanismList())
  return (
    <Grid marginTop={2} size={12}>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{t('loan.financingFeeConfiguration.configuration')}</Typography>
          </Stack>
        </Grid>
        <Grid size={4}>
          <ControlledSelect
            control={control}
            name="loanData.financeFeeConfig.billingMethodId"
            label={t('loan.financingFeeConfiguration.billingMechanism')}
            options={billingMechanismOption}
          />
        </Grid>

        <Grid size={4}>
          <ControlledDateOnlyPicker
            control={control}
            name="loanData.financeFeeConfig.amortizationStartsOn"
            label={t('loan.financingFeeConfiguration.amortizationStartsOn')} // Rajouter la valeur par défaut
          />
        </Grid>

        <Grid size={4}>
          <ControlledTextField
            control={control}
            name="loanData.financeFeeConfig.feeRate"
            type="number"
            label={t('loan.financingFeeConfiguration.interestRate')}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default FeeConfigurationInputRow
